<div class="lhcb-coupon-banner">
  <div class="lhcb-coupon-banner__icon">
    <i class="fa fa-gift" aria-hidden="true"></i>
  </div>
  <div class="lhcb-coupon-banner__content">
    <div
      *ngIf="isPoaPriceLoaded"
      class="lhcb-coupon-banner__title"
      [innerHTML]="'LHCB_MIGRATION_POPUP.BANNER_TITLE_HTML' | translate : { poaPrice: poaPriceDisplay }"
    ></div>
    <div
      class="lhcb-coupon-banner__code"
      role="button"
      tabindex="0"
      [attr.title]="'LHCB_MIGRATION_POPUP.BANNER_CLICK_TO_COPY' | translate"
      [attr.aria-label]="'LHCB_MIGRATION_POPUP.BANNER_CLICK_TO_COPY' | translate"
      (click)="copyToClipboard()"
      (keyup.enter)="copyToClipboard()"
      (keyup.space)="copyToClipboard()"
    >
      <span class="lhcb-coupon-banner__code-label">
        {{ (isCopied ? "LHCB_MIGRATION_POPUP.BANNER_COPIED" : "LHCB_MIGRATION_POPUP.BANNER_CODE_LABEL") | translate }}
      </span>
      <span class="lhcb-coupon-banner__code-value">{{ couponCode }}</span>
    </div>
    <div class="lhcb-coupon-banner__subtitle">
      {{ "LHCB_MIGRATION_POPUP.BANNER_SUBTITLE" | translate }}
    </div>
  </div>
</div>
